/**
 * Generates an array of month strings (e.g., "M01_2024") for a given range.
 * @param {number} [pastCount=15] - Number of months to include from the past.
 * @param {number} [futureCount=15] - Number of months to include into the future.
 * @returns {string[]} An array of month strings.
 */
export const generateMonths = (pastCount = 15, futureCount = 15) => {
    const months = [];
    const currentDate = new Date();

    let pastYear = currentDate.getFullYear();
    let pastMonth = currentDate.getMonth() + 1;
    for (let i = 0; i < pastCount; i++) {
        pastMonth--;
        if (pastMonth === 0) {
            pastMonth = 12;
            pastYear--;
        }
        const monthStr = `M${pastMonth < 10 ? `0${pastMonth}` : pastMonth}_${pastYear}`;
        months.unshift(monthStr);
    }

    const currentMonthIndex = currentDate.getMonth() + 1;
    const currentMonthStr = `M${currentMonthIndex < 10 ? `0${currentMonthIndex}` : currentMonthIndex}_${currentDate.getFullYear()}`;
    months.push(currentMonthStr);

    let futureYear = currentDate.getFullYear();
    let futureMonth = currentDate.getMonth() + 1;
    for (let i = 0; i < futureCount; i++) {
        futureMonth++;
        if (futureMonth === 13) {
            futureMonth = 1;
            futureYear++;
        }
        const monthStr = `M${futureMonth < 10 ? `0${futureMonth}` : futureMonth}_${futureYear}`;
        months.push(monthStr);
    }

    return [...new Set(months)];
};

export const DEFAULT_MONTH_RANGE = generateMonths(15, 15);